<template>
    <div>
    	<b-form-select v-model="filter['logic']" :options="dateOptions" :size="size" />

    	<div v-if="filter['logic'] == 'between'" class="row mt-1">
    	    <div class="col-sm-6 input-group-sm">
    	        <input type="date" v-model="filter['value']" :class="{'form-control': true, 'is-invalid': error}" placeholder="Enter Start Date" />
    	    </div>
    	    <div class="col-sm-6 input-group-sm">
    	        <input type="date" v-model="filter['value2']" :class="{'form-control': true, 'is-invalid': error}" placeholder="Enter End Date" />
    	    </div>
    	</div>
    	<div v-if="filter['logic'] == 'greater_than_or_equal' || filter['logic'] == 'less_than_or_equal'" :class="'input-group-'+size+' mt-1'">
    	    <input type="date" v-model="filter['value']" :class="{'form-control': true, 'is-invalid': error}" placeholder="Enter Date" />
    	</div>
    	<div v-if="filter['logic'] == 'rolling_past' || filter['logic'] == 'rolling_future'" class="input-group input-group-sm mt-1">
    	    <input type="number" v-model="filter['value']" :class="{'form-control': true, 'is-invalid': error}" placeholder="Enter Number of Days" />
    	    <div class="input-group-append">
    	        <div class="input-group-text bg-light">Days</div>
    	    </div>
    	</div>
    </div>
</template>

<script>
    export default {
        props: {
            filter: {
                type: Object,
                required: true,
            },

            size: {
            	type: String,
            	default: 'md',
            },

            error: {
            	type: Array,
            },
        },

        data() {
            return {
            	dateOptions: [
            	    { value: null, text: '-- Select Date Filter --' },
            	    {
            	        label: 'Calendar Year',
            	        options: [
            	            { value: 'ytd', text: 'YTD: Jan. 1st - Current Date' },
                            { value: 'current_year', text: 'This Year' },
            	        ]
            	    },
            	    {
            	        label: 'Calendar Quarters',
            	        options: [
            	            { value: 'current_q1', text: 'Current Year - Q1' },
            	            { value: 'current_q2', text: 'Current Year - Q2' },
            	            { value: 'current_q3', text: 'Current Year - Q3' },
            	            { value: 'current_q4', text: 'Current Year - Q4' },
            	        ]
            	    },
            	    {
            	        label: 'Calendar Month',
            	        options: [
            	            { value: 'month_last', text: 'Last Month' },
            	            { value: 'month_current', text: 'This Month' },
            	            { value: 'month_next', text: 'Next Month' },
            	        ]
            	    },
            	    {
            	        label: 'Calendar Week',
            	        options: [
            	            { value: 'calendar_last_week', text: 'Last Week' },
            	            { value: 'calendar_this_week', text: 'This Week' },
            	            { value: 'calendar_next_week', text: 'Next Week' },
            	        ]
            	    },
            	    {
            	        label: 'Days',
            	        options: [
            	            { value: 'yesterday', text: 'Yesterday' },
            	            { value: 'today', text: 'Today' },
            	            { value: 'tomorrow', text: 'Tomorrow' },
            	            { value: 'last_7_days', text: 'Last 7 Days' },
            	            { value: 'last_30_days', text: 'Last 30 Days' },
            	            { value: 'last_60_days', text: 'Last 60 Days' },
            	            { value: 'last_90_days', text: 'Last 90 Days' },
            	            { value: 'last_120_days', text: 'Last 120 Days' },
            	            { value: 'next_7_days', text: 'Next 7 Days' },
            	            { value: 'next_30_days', text: 'Next 30 Days' },
            	            { value: 'next_60_days', text: 'Next 60 Days' },
            	            { value: 'next_90_days', text: 'Next 90 Days' },
            	            { value: 'next_120_days', text: 'Next 120 Days' },
            	        ]
            	    },
            	    {
            	        label: 'Custom',
            	        options: [
            	            { value: 'between', text: 'Between' },
            	            { value: 'greater_than_or_equal', text: 'Greater Than or Equal To' },
            	            { value: 'less_than_or_equal', text: 'Less Than or Equal To' },
            	            { value: 'rolling_past', text: 'Last [X] Days' },
            	            { value: 'rolling_future', text: 'Future [X] Days' },
            	        ]
            	    },
            	]
            }
        },

        watch: {

        },

        computed: {

        },

        methods: {

        },

        mounted() {

        }
    }
</script>
